import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { maybeSlugToUuid } from '#pplx/frontend/apps/ask/permalink-slug/permalinkSlug.js';
import { ENTRY_EXPIRED, RedirectReason, VIEW_THREAD_NOT_ALLOWED, } from '#pplx/frontend/components/utils/PrivacyUtils.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { redirectWindow } from '#pplx/frontend/platform-components/redirectWindow.js';
import { useRouter } from '#pplx/frontend/router/provider.js';
import { useCallback, useEffect } from 'react';
export const isThreadAccessNotAllowedError = (error) => error instanceof ApiClientsError && error.detail?.error_code === VIEW_THREAD_NOT_ALLOWED;
export function useThreadAccessErrorRedirect({ error, slugOrUUID, useHardRedirect = false, invalidReason = RedirectReason.InvalidThread, redirectBasePath = '/', }) {
    const router = useRouter();
    const redirect = useCallback((url, reason) => useHardRedirect ? redirectWindow(url, reason) : router.replace(url, reason), [useHardRedirect, router]);
    useEffect(() => {
        if (isThreadAccessNotAllowedError(error)) {
            logger.error(VIEW_THREAD_NOT_ALLOWED, { status: error.status });
            return;
        }
        if (!(error instanceof ApiClientsError))
            return;
        const detail = error.detail;
        let reason;
        if (detail?.error_code === ENTRY_EXPIRED) {
            reason = RedirectReason.ThreadExpired;
            logger.error(ENTRY_EXPIRED, { status: error.status });
        }
        else {
            reason = invalidReason;
            logger.error('Thread access error', {
                errorCode: detail?.error_code,
                status: error.status,
            });
        }
        const separator = redirectBasePath.includes('?') ? '&' : '?';
        const safeIdentifier = maybeSlugToUuid(slugOrUUID);
        const idParam = safeIdentifier === null ? '' : `&id=${encodeURIComponent(safeIdentifier)}`;
        redirect(`${redirectBasePath}${separator}error=${reason}${idParam}`, 'Thread access error');
    }, [error, slugOrUUID, redirect, invalidReason, redirectBasePath]);
}
//# sourceMappingURL=useThreadAccessErrorRedirect.js.map